@if (projectReference) {
  <a class="block absolute inset-0 w-full h-full hover-focus:transform-photo-scale" routerLink="/project-references/{{projectReference.id}}">
    <app-photo class="absolute inset-0 w-full h-full" [photo]="projectReference.primaryPhoto" sizes="100vw"></app-photo>
    <div class="absolute h-2/4 pl-5 lg:pl-10 pb-5 lg:pb-10 flex flex-col justify-end left-0 right-0 bottom-0 from-imageGradient to-imageGradient-1 bg-gradient-to-t">
      <div class="font-medium text-lg lg:text-2xl text-white leading-none mb-1">{{getRelevantProjectHandle(projectReference.commercialProjectName, projectReference.name)}}</div>
      <div class="text-sm lg:text-base text-white leading-none opacity-80">{{projectReference.companyName}}</div>
      <div class="text-sm lg:text-base text-white leading-none opacity-80">{{projectReference.city}}</div>
    </div>
  </a>
}
